import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import queryString from 'query-string';
import _ from 'lodash';
import SimpleReactValidator from 'simple-react-validator';

import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';


import { history } from '../../../shared/configure-store';
import Api from '../../../libraries/api';
import AuthHelper from '../../../libraries/auth-helper';
import TablePaginationActions from '../../presentational/table-pagination-actions';

require('dotenv').config();

class RegionalSetupEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loadingButton: false,
            loadingTable: false,
            errors: {},
            regional_codes: [],
            corporate_customers: [],
            id: '',
            regional_name: '',
            regional_code: '',
            first_user_id_from_list_customer: null,
            users: [],
            user_ids: [],
            user_id: null,
            rows: [],
            total: 0,
            perPage: 10,
            currentPage: 0,
            isManage: false,
            currRemove: null,
            isOriginalDataChanged: false,
            showDialogAssignCustomer: false,
            showDialogRemoveCustomer: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.validator = new SimpleReactValidator({
            messages: {
                required: 'Field ini wajib diisi',
                min: 'Silakan pilih minimal satu customer',
            },
        });

        this.validatorAssign = new SimpleReactValidator({
            messages: {
                required: 'Field ini wajib diisi',
            },
        });
    }

    componentDidMount() {
        document.title = 'Gudangemas - Ubah Regional Setup';
        let profile = AuthHelper.getProfile();

        if (profile['map-menu']) {
            let roles = profile['map-menu'].map((o) => ({
                id: o.id,
                name: o.menu.name,
                isManage: o.isManage,
            }));

            // TODO: FIX PERMISSION TO REGIONAL SETUP
            let all = roles.filter(item => item.name === 'Customer');
            this.setState({ isManage: all.length > 0 ? all[0].isManage : false });
        }

        this.fetchData();
        this.fetchDataListCustomers();
        this.fetchRegionalCodes();
        this.fetchCorporateCustomers();
    }

    fetchData = () => {
        const queryParams = queryString.parse(this.props.location.search);
        const regionalCodeParams = queryParams.regional_code ? decodeURIComponent(queryParams.regional_code) : '';
        const regionalNameParams = queryParams.regional_name ? decodeURIComponent(queryParams.regional_name) : '';
        const params = { page: 0, size: 10, regional_code: regionalCodeParams, regional_name: regionalNameParams };
    
        Api.post('/region/setup/find', params)
            .then((resp) => {
                if (resp.status === 200) {
                    const data = resp.data.content[0];
                    this.setState({ 
                        regional_name: regionalNameParams,
                        regional_code: regionalCodeParams,
                        first_user_id_from_list_customer: data.user_id || null,
                    });
                }
            })
            .catch(() => {
                this.showMessage(false, 'Gagal mengambil data regional setup');
            });
    };

    fetchDataListCustomers = () => {
        const queryParams = queryString.parse(this.props.location.search);
        const regionalCodeParams = queryParams.regional_code ? decodeURIComponent(queryParams.regional_code) : '';
        const regionalNameParams = queryParams.regional_name ? decodeURIComponent(queryParams.regional_name) : '';
        const params = { page: 0, size: 50, regional_code: regionalCodeParams, regional_name: regionalNameParams, is_deleted: false };
    
        Api.post('/region/setup/find-customer', params)
            .then((resp) => {
                if (resp.status === 200) {
                    const data = resp.data;
                    const user_ids = data.content.map((item) => item.user_id);
                    this.setState({
                        user_ids,
                        rows: data.content,
                        total: data.totalElements,
                        currentPage: data.number,
                        totalPages: data.totalPages,
                        loading: false,
                    });

                    // NOTE: Konfirmasi dengan BE kenapa harus pakai salah satu user_id di regional setup ini untuk params edit nama regional & kode regional
                    if (data.content.length > 0) {
                        const first_user_id = data.content[0].user_id;
                        this.setState({ first_user_id_from_list_customer: first_user_id });
                    }
                }
            })
            .catch(() => {
                this.showMessage(false, 'Gagal mengambil list customer untuk regional ini');
            });
    };

    fetchRegionalCodes = () => {
        Api.get('/region/master').then(resp => {
            if (resp.data) {
                let all = [];
                _.forEach(resp.data, (v, k) => all.push(v));
                this.setState({ regional_codes: all, loading: false });
            }
        });
    };

    fetchCorporateCustomers = () => {
        const params = { page: 0, size: 1000, 'type-of-customer': 'CORPORATE' };
    
        Api.post('/customer/get-all', params)
            .then((resp) => {
                if (resp.data && resp.data.customers) {
                    const corporateCustomers = resp.data.customers.map((c) => ({
                        id: c['id-customer'],
                        username: c.username,
                        companyName: c.companyName,
                    }));
    
                    this.setState({ corporate_customers: corporateCustomers });
                }
            })
            .catch((err) => console.log(err));
    };

    showMessage = (status, message) => toast[status ? 'success' : 'error'](message, { position: toast.POSITION.BOTTOM_RIGHT });

    handleChange = (e, prop) => {
        if (prop === 'regional_name' || prop === 'regional_code') {
            this.setState({ isOriginalDataChanged: true });
        }

        this.setState({ [prop]: e.target.value });
    } 

    handleShowAssignCustomer = () => {
        if (this.state.isOriginalDataChanged) {
            this.showMessage(false, 'Silakan simpan atatu batalkan perubahan data regional terlebih dahulu');
            return;
        }
        this.setState({ showDialogAssignCustomer: true });
    };

    handleCloseAssignCustomer = () => this.setState({ showDialogAssignCustomer: false, errors: {} });

    handleShowRemoveCustomer = (row) => this.setState({ currRemove: row, showDialogRemoveCustomer: true ,errors: {} });

    handleCloseRemoveCustomer = () => this.setState({ currRemove: null, showDialogRemoveCustomer: false, errors: {} });
        
    handleSubmitAssignCustomer = (e) => {
        e.preventDefault();

        if (!this.validatorAssign.allValid()) {
            this.setState({ errors: this.validatorAssign.getErrorMessages() });
            return;
        }
        
        const params = {
            single_user_id: this.state.user_id,
            regional_name: this.state.regional_name,
            regional_code: this.state.regional_code,
        };

        this.setState({ loadingTable: true });

        Api.post('/region/setup/add', params)
            .then(() => {
                this.showMessage(true, 'Customer berhasil ditambahkan ke regional ini');
                this.handleCloseAssignCustomer();
                this.fetchDataListCustomers();
            })
            .catch((errors) => {
                this.showMessage(false, 'Gagal menambahkan customer ke regional ini');
                console.log(errors);
            })
            .finally(() => {
                this.setState({ loadingTable: false });
            });
    };

    handleSubmitRemoveCustomer = (e) => {
        e.preventDefault();

        if (this.state.currRemove === null) {
            this.showMessage(false, 'Silakan pilih customer yang ingin dihapus terlebih dahulu');
        }

        const params = {
            id_user: this.state.currRemove.user_id,
            regional_code: this.state.currRemove.regional_code,
            flag_all: false,
        };

        this.setState({ loadingTable: true });

        Api.delete('/region/setup/hard-delete', params)
            .then(() => {
                this.showMessage(true, 'Customer berhasil dihapus dari regional ini');
                this.handleCloseRemoveCustomer();
                this.fetchDataListCustomers();
            })
            .catch((errors) => {
                this.showMessage(false, 'Gagal menghapus customer dari regional ini');
                console.log(errors);
            })
            .finally(() => {
                this.setState({ loadingTable: false });
            });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        if (!this.validator.allValid()) {
            this.setState({ errors: this.validator.getErrorMessages() });
            return;
        }

        this.setState({ loadingButton: true });

        const params = {
            regional_name: this.state.regional_name,
            regional_code: this.state.regional_code,
            // NOTE: Konfirmasi dengan BE kenapa harus pakai salah satu user_id di regional setup ini untuk params edit nama regional & kode regional
            id_user : this.state.first_user_id_from_list_customer,
            is_deleted: false,
        };

        Api.put('/region/setup', params)
            .then(() => {
                this.setState({ isOriginalDataChanged: false });
                toast.success('Regional setup berhasil diubah');
                history.push('/regional-setup');
            })
            .catch(() => {
                toast.error('Gagal memperbarui regional setup');
                this.setState({ loadingButton: false });
            });
    };


    render() {
        return (
            <div className="row main-content">
                <div className="col-12">
                    <h1 className="page-title">Detail Regional Setup</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/regional-setup">Regional Setup</Link></li>
                            <li className="breadcrumb-item active">Ubah</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12">
                    <div className="table-wrapper">
                        <div className="row align-items-center content-title">
                            <div className="col-6">
                                <h2 className="mb-0">Ubah Regional Setup</h2>
                            </div>
                        </div>
                        <div className="box-border">
                            <h3 className="section-title"></h3>
                            <form onSubmit={this.handleSubmit} noValidate>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Nama Komunitas</label>
                                            <TextField
                                                variant="outlined"
                                                value={this.state.regional_name}
                                                onChange={(e) => this.handleChange(e, 'regional_name')}
                                                error={this.state.errors.regional_name}
                                                helperText={this.state.errors.regional_name}
                                                fullWidth
                                            />
                                            {this.validator.message('regional_name', this.state.regional_name, 'required')}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Kode Regional</label>
                                            <TextField 
                                                id="regional_code"
                                                name="regional_code"
                                                variant="outlined"
                                                error={this.state.errors.regional_code}
                                                helperText={this.state.errors.regional_code}
                                                value={this.state.regional_code}
                                                onChange={(e) => this.handleChange(e, 'regional_code')}
                                                select
                                                fullWidth
                                            >
                                                {this.state.regional_codes.map(option => (<MenuItem key={option.regional_code} value={option.regional_code}>{option.regional_code}</MenuItem>))}
                                            </TextField>
                                            {this.validator.message('regional_code', this.state.regional_code, 'required')}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 text-center mt-4">
                                        <Button
                                            variant="contained"
                                            onClick={() => history.push('/regional-setup')}
                                            className="mr-3"
                                        >
                                            Batal
                                        </Button>
                                        {this.state.isManage && (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                type="submit"
                                                disabled={this.state.loadingButton}
                                            >
                                                Simpan
                                                {this.state.loadingButton && (<span className="ml-2 spinner-border spinner-border-sm" />)}
                                            </Button>
                                        )}
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div className="table-wrapper pb-1">
                            <div className="row align-items-center content-title">
                                <div className="col-6">
                                    <h3 className="mb-0">List Customer (Corporate)</h3>
                                </div>
                                <div className="col-6 text-right">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => this.handleShowAssignCustomer()}
                                    >
                                        <i className="fas fa-plus mr-2"></i>
                                        Tambah Customer
                                    </Button>
                                </div>
                            </div>
                            <div className="table-list row">
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className="clickable" onClick={() => this.handleSort('username')}>
                                                Username
                                                {this.state.orderBy === 'username' && (<span className="icon-sort">{this.state.sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                            </TableCell>
                                            <TableCell className="clickable" onClick={() => this.handleSort('companyName')}>
                                                Nama Company
                                                {this.state.orderBy === 'companyName' && (<span className="icon-sort">{this.state.sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                            </TableCell>
                                            <TableCell>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.loading ? (
                                            <TableRow>
                                                <TableCell colSpan={3} align="center" className="py-5"><CircularProgress color="primary" /></TableCell>
                                            </TableRow>
                                        ) : this.state.rows.length === 0 ? (
                                            <TableRow style={{ height: 33 * this.state.perPage }}>
                                                <TableCell colSpan={3} style={{ textAlign: 'center' }}>Data Customer kosong</TableCell>
                                            </TableRow>
                                        ) : (
                                            this.state.rows.map((row) => (
                                                <TableRow key={row.user_id}>
                                                    <TableCell>{row.username}</TableCell>
                                                    <TableCell>{row.company_name}</TableCell>
                                                    <TableCell className="action-menu">
                                                        <button className="btn-icon">
                                                            <i className="fas fa-ellipsis-v"></i>
                                                        </button>
                                                        <div className="action-wrap">
                                                            <Link to={"/customers/edit/"+row['user_id']} className="btn-icon mb-2">
                                                                <i className="fas fa-pencil-alt"> </i> Detail
                                                            </Link>
                                                            <button className="btn-icon" type='button' onClick={() => this.handleShowRemoveCustomer(row)}><i className="fas fa-trash-alt"></i> Hapus</button>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>
                                </Table>
                            </div>
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 50]}
                                component="div"
                                count={this.state.total}
                                rowsPerPage={this.state.perPage}
                                page={this.state.currentPage}
                                backIconButtonProps={{ 'aria-label': 'previous page' }}
                                nextIconButtonProps={{ 'aria-label': 'next page' }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            />
                        </div>
                    </div>
                </div>
                <Dialog
                    maxWidth="sm"
                    fullWidth={true}
                    open={this.state.showDialogAssignCustomer}
                    onClose={this.handleCloseAssignCustomer}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">Tambah Customer ke Regional Ini</DialogTitle>
                    <DialogContent>
                        <form className='row' noValidate>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Username - Company</label>
                                    <TextField 
                                        id="user_id"
                                        name="user_id"
                                        variant="outlined"
                                        value={this.state.user_id}
                                        error={this.state.errors.user_id}
                                        helperText={this.state.errors.user_id}
                                        onChange={(e) => this.handleChange(e, 'user_id')}
                                        select
                                        fullWidth
                                    >
                                        {this.state.corporate_customers.map(option => (<MenuItem key={option.id} value={option.id}>{option.username} - {option.companyName}</MenuItem>))}
                                    </TextField>
                                    {this.validatorAssign.message('user_id', this.state.user_id, 'required')}
                                </div>
                            </div>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <button className="btn btn-blue-trans" onClick={this.handleCloseAssignCustomer}>Batal</button>
                        <button className="btn btn-blue" onClick={this.handleSubmitAssignCustomer}>Tambah</button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    maxWidth="sm"
                    fullWidth={true}
                    open={this.state.showDialogRemoveCustomer}
                    onClose={this.handleCloseRemoveCustomer}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">KONFIRMASI</DialogTitle>
                    <DialogContent>
                        <p>
                            Apakah anda yakin akan menghapus customer 
                            <br />(<strong>{this.state.currRemove ? this.state.currRemove.username : '-'} - {this.state.currRemove ? this.state.currRemove.company_name : '-'}</strong>) 
                            dari regional ini ?
                        </p>
                    </DialogContent>
                    <DialogActions>
                        <button className="btn btn-blue-trans" onClick={this.handleCloseRemoveCustomer}>Batal</button>
                        <button className="btn btn-blue" onClick={this.handleSubmitRemoveCustomer}>Hapus</button>
                    </DialogActions>
                </Dialog>

                <ToastContainer />
            </div>
        );
    }
}

export default RegionalSetupEdit;